import { bindable, inject } from "aurelia-framework";
import { ProductfinderResult, Pumpe } from "./productfinder-result";
import { ReportService } from "../../services/report/report-service";
import { KrachtPumpenReport } from "./report/kracht-pumpen-report";

@inject(ReportService, KrachtPumpenReport)
export class KPump {
  @bindable result: ProductfinderResult;
  @bindable index: number;
  @bindable collapseddiagram: boolean = true;

  constructor(
    private reportService: ReportService,
    private krachtPumpenReport: KrachtPumpenReport,
  ) {}

  get pump(): Pumpe {
    return this.result.pumpen![this.index];
  }

  getPumpImageName() {
    return (
      "img/pumps/" +
      this.pump.pumpentyp.text.toUpperCase().replace(/[ ,]/g, "_") +
      ".jpg"
    );
  }

  createPDF() {
    let orig_collapseddiagram = this.collapseddiagram;
    this.collapseddiagram = false;
    setTimeout(() => {
      this._createPDF();
      this.collapseddiagram = orig_collapseddiagram;
    }, 350);
  }

  private _createPDF() {
    let imagePumpe = this.getImagePumpe();
    let definition = this.krachtPumpenReport.createDefinition(
      this.result,
      this.index,
      imagePumpe,
    );
    this.reportService.createAndDownloadReport(
      definition,
      this.getPDFFilename(),
    );
    //this.reportService.openReport(definition);
  }

  private getImagePumpe() {
    let canvas = document.getElementById(
      "chartCanvas" + this.index,
    ) as HTMLCanvasElement;
    return canvas.toDataURL();
  }

  private getPDFFilename() {
    let pumpenName = this.encode(this.pump.pumpentyp.text);
    return `KRACHT-Pumpenberechnung-${pumpenName}.pdf`;
  }

  private encode(s: string) {
    return s.replace(/[ .,#]/g, "_");
  }
}
